import { useTranslation } from 'react-i18next';
import { Logo } from '../../components/navigation/components/Logo';

const ResetPasswordSuccessView = () => {
  const { t } = useTranslation();

  return (
    <div className="px-8 py-8 mx-auto flex flex-col max-w-xl h-screen justify-center">
      <Logo />
      <h1 className="mt-12 text-black700">{t('resetPasswordSuccess.title')}</h1>
      <p className="mt-4 text-black500 font-medium leading-snug">{t('resetPasswordSuccess.description')}</p>
    </div>
  );
};

export default ResetPasswordSuccessView;
